import { GoogleLogin } from "@react-oauth/google"
import Sentry from "integrations/sentry"

type LoginProps = {
  // Receives the raw Google ID token; the server verifies it and derives identity
  setCredential: React.Dispatch<React.SetStateAction<string | null>>
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
}

const GoogleOAuth = ({ setCredential, setErrorMessage }: LoginProps) => {
  const handleGoogleLoginSuccess = (response) => {
    if (!response.credential) {
      errorMessage()
      return
    }
    setCredential(response.credential)
  }
  const errorMessage = () => {
    setErrorMessage(
      "Sorry, we encountered an error while attempting to sign you in with Google. Please try again later or contact support if the issue persists."
    )
    Sentry.captureException("Error with Google Oauth Login")
  }

  return <GoogleLogin onSuccess={handleGoogleLoginSuccess} onError={errorMessage} width="384px" />
}

export default GoogleOAuth
